// src/components/technician/TechnicianHelp.jsx
import React from "react";
import { Box, Card, CardContent, Typography, Accordion, AccordionSummary,
         AccordionDetails, Alert } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// Added local COLORS object to fix the undefined error
const COLORS = {
  primary:       "#2563eb",
  textPrimary:   "#0f172a",
  textSecondary: "#64748b",
};

const FAQS = [
  {
    q: "How do I see my assigned tickets?",
    a: "Open My Tickets from the sidebar. Only tickets where you are the assigned technician will appear. You can filter by status or search by ticket number, customer name, or asset.",
  },
  {
    q: "Can I edit the customer's asset warranty?",
    a: "No. Warranty, sales, financial, and procurement information on assets is restricted. Warranty details are shown read-only. Contact your administrator if a warranty record is wrong.",
  },
  {
    q: "What statuses can I move a ticket to?",
    a: "Only the transitions allowed by the current ticket workflow. For example, an open ticket can move to In Progress or Pending; an In Progress ticket can move to Pending or Resolved. Closed tickets cannot be edited.",
  },
  {
    q: "How do I resolve a ticket?",
    a: "Change status to Resolved, fill in the Resolution Notes describing what you fixed, and click Save Update. The resolution is permanently recorded on the ticket.",
  },
  {
    q: "Can I reassign a ticket to another technician?",
    a: "Reassignment is handled by your administrator through the admin help desk. Raise a request via email if you need to hand off a ticket.",
  },
];

const TechnicianHelp = () => (
  <Box>
    <Typography variant="h5" fontWeight={700} mb={0.5}>Help</Typography>
    <Typography variant="body2" color="text.secondary" mb={3}>
      Guidance for technicians on using the ticket workflow.
    </Typography>

    <Alert severity="info" sx={{ mb: 3 }}>
      <b>Permission reminder:</b> Your account can view and update tickets assigned to you.
      You cannot modify asset sales, financial, procurement, or warranty information.
    </Alert>

    <Card elevation={0} sx={{ border: "1px solid #e5e7eb", borderRadius: 3, mb: 3 }}>
      <CardContent>
        <Typography fontWeight={700} mb={2}>Frequently Asked Questions</Typography>
        {FAQS.map((f, i) => (
          <Accordion key={i} disableGutters elevation={0}
                     sx={{ "&:before": { display: "none" }, border: "1px solid #f1f5f9", mb: 1, borderRadius: 2 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography fontWeight={600} fontSize="0.9rem">{f.q}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" color="text.secondary">{f.a}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </CardContent>
    </Card>

    <Card elevation={0} sx={{ border: "1px solid #e5e7eb", borderRadius: 3 }}>
      <CardContent sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
        <Box sx={{ flex: 1 }}>
          <Typography fontWeight={700}>Still need help?</Typography>
          <Typography variant="body2" color="text.secondary">
           Email the support team at{" "}
           <Box component="span" sx={{ fontWeight: 600, color: COLORS.textPrimary }}>
             admin@infapp.biz
           </Box>
          </Typography>
        </Box>
      </CardContent>
    </Card>
  </Box>
);

export default TechnicianHelp;